// extracted by mini-css-extract-plugin
export default {"slideContainer":"_9f25dbc11a _697eaba18a b5f09a9366","slideImage":"_36f79962a3"};